export default function getActivePlaylistShowButtonLocaleKey(user, Cohort) {
    return user?.relevantCohort?.showButtonKey || Cohort.showButtonKey(user?.programType) || 'show_playlists';
}
